"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacyPolicyAndProtectionOfPersonalData = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("./styles");
var Layout_1 = __importDefault(require("../Layout"));
var privacy_policy_and_protection_of_personal_data_docx_1 = __importDefault(require("../../static/docs/privacy-policy-and-protection-of-personal-data.docx"));
function PrivacyPolicyAndProtectionOfPersonalData() {
    return ((0, jsx_runtime_1.jsx)(Layout_1.default, { children: (0, jsx_runtime_1.jsx)(styles_1.Content, { dangerouslySetInnerHTML: { __html: privacy_policy_and_protection_of_personal_data_docx_1.default } }) }));
}
exports.PrivacyPolicyAndProtectionOfPersonalData = PrivacyPolicyAndProtectionOfPersonalData;
